import { Extension } from "@tiptap/core";

export default Extension.create({
  name: "Autosave",
  addOptions() {
    return {
      autoSaveUrl: "",
      autoSave: false,
    };
  },
  addCommands() {
    return {
      save: (event) => ({ editor }) => {
        if (!this.options.autoSave) {
          return;
        }

        const form = editor.options.element.closest("form");
        if (!form) {
          console.error("Form not found");
          return;
        }

        if (typeof this.options.autoSaveUrl !== "undefined" && this.options.autoSaveUrl !== "") {
          const content = editor.getHTML();
          const data = { html: content };
          const token = document.head.querySelector("meta[name=\"csrf-token\"]");

          fetch(this.options.autoSaveUrl, {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json",
              "X-CSRF-Token": token.content,
            },
            credentials: "same-origin",
            body: JSON.stringify(data),
          });
        }
      },
    };
  },
});
